import { render, staticRenderFns } from "./StoreErrorsNew.vue?vue&type=template&id=53c3bc82&"
import script from "./StoreErrorsNew.vue?vue&type=script&lang=js&"
export * from "./StoreErrorsNew.vue?vue&type=script&lang=js&"
import style0 from "./StoreErrorsNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports